import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { ProductionKeyValuePairGet } from "../../../models/ProductionKeyValuePair"
import { useHashTab } from "../../../../hooks/useHashTab"
import { KeyValuePairDetails } from "./details_tab/KeyValuePairDetails"

const returnURL = "/production#keyValuePairs"

export function KeyValuePairContainer() {
  const { productionKeyValuePairId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [productionKeyValuePair, setProductionKeyValuePair] =
    useState<ProductionKeyValuePairGet>()

  useEffect(() => {
    if (productionKeyValuePairId) {
      digitalManagerApi
        .get<ProductionKeyValuePairGet>(
          `/production/keyValuePairs/${productionKeyValuePairId}`
        )
        .then((res) => {
          setProductionKeyValuePair(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, productionKeyValuePairId])

  if (!productionKeyValuePairId) {
    return <Navigate to={returnURL} />
  }

  if (!productionKeyValuePair) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: productionKeyValuePair.key,
    label: "Production Key-Value Pair ID",
    subtitle: productionKeyValuePair.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <KeyValuePairDetails
          productionKeyValuePair={productionKeyValuePair}
          setProductionKeyValuePair={setProductionKeyValuePair}
        />
      )}
    </div>
  )
}
